/**
 * ! background-image: url(...) seems to not work with HEX colors – have to use default keys instead (hence the TBackgroundIconColor)
 * also the svg strings should stay on one line
 */

export type TBackgroundIconColor = 'white' | 'black' | 'lightGrey' | 'grey' // colors allowed for the background icon – feel free to extend

// check mark
export const getMarkIcon = (color: TBackgroundIconColor) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" name="check"><path fill="${color}" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" stroke-linecap="round" /></svg>`
}

// remove icon
export const getCrossIcon = (color: TBackgroundIconColor) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" name="cross"><path fill="${color}" d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" stroke-linecap="round"/></svg>`
}
